export type Article = {
  slug: string;
  column: string;
  title: string;
  lead: string;
  tags: string[];
  date: string;
  readTime: string;
  author: string;
  cover: string;
  content: string[];
};

export const articles: Article[] = [
  {
    slug: 'zi-laishui-baohong-moxing',
    column: 'shenba',
    title: '深扒一场"自来水"爆红：冷启动到全民讨论，中间被谁点了一把火',
    lead:
      '当一段内容突然刷屏时，很多人以为是"网友自发的自来水"。这一篇我们顺着时间戳回看一场真实的出圈路径，看看冷启动到爆红之间，究竟藏着哪几步关键动作。',
    tags: ['爆款拆解', '宣发节奏', '出圈路径'],
    date: '2026-09-03',
    readTime: '9 分钟',
    author: '阿刀',
    cover:
      'https://readdy.ai/api/search-image?query=Editorial%20scene%20of%20a%20spark%20igniting%20a%20chain%20reaction%20of%20paper%20flames%20spreading%20across%20warm%20newsprint%20surface%2C%20red%20threads%20linking%20nodes%20of%20a%20viral%20event%20map%2C%20muted%20crimson%20and%20amber%20against%20cream%20paper%2C%20investigative%20journalism%20visual%20metaphor%2C%20cinematic%20soft%20lighting%2C%20high%20detail%20film%20grain&width=900&height=560&seq=art-zilaishui&orientation=landscape',
    content: [
      '一条内容从无人问津到霸占首页，看起来像一场突然的集体狂欢。可若把后台的每小时热度曲线拉出来，会发现多数所谓"一夜爆红"都有清晰的分段：冷启动、破圈、跟风发酵、话题沉淀。本文不预设好坏，只把这几步拆开，供你对照理解。',
      '冷启动阶段往往最容易被忽略。真正能起来的选题，通常不是凭空出现，而是在某个细分的圈层里先获得高密度回应——转发率、二创率远高于点赞率，说明内容击中的不是"喜欢"，而是"想表达"。第一把火，往往不是撒向全网，而是精准地点进第一批愿意为它发言的人心里。',
      '到了破圈阶段，节奏比内容本身更敏感。几条大号转发的时间差、评论区前几十条的态度方向、甚至平台推荐位的先后，都会影响大众的第一印象。我们不做阴谋论式的归因，只想提醒：当你看到"大家都在说"的时候，大概率已经处在发酵的第三四棒，最初的源头往往要往前翻很久。',
      '最后是沉淀。真正能被记住的内容事件，会在热度过去后留下可供复盘的东西：一个稳定的情绪议题、一个被反复引用的梗，或一种值得讨论的价值冲突。看料社更在意的，正是热度褪去后剩下的这层脉络。',
    ],
  },
  {
    slug: 'zhenrenxiu-jianji-jiezou',
    column: 'shenba',
    title: '真人秀的"爆点"是剪出来的：情绪节奏与叙事钩子的设计逻辑',
    lead:
      '同样一天拍摄，不同剪辑能把嘉宾塑造成完全不同的性格。这一篇用编辑部视角拆解真人秀剪辑里最常用的情绪设计手法，让你下次看得更明白。',
    tags: ['真人秀', '剪辑逻辑', '叙事设计'],
    date: '2026-08-28',
    readTime: '8 分钟',
    author: '罐头',
    cover:
      'https://readdy.ai/api/search-image?query=Editorial%20montage%20of%20film%20editing%20timeline%20strips%20on%20warm%20desk%20with%20emotion%20beat%20cards%20and%20reaction%20arrows%2C%20clapperboard%20in%20soft%20shadow%2C%20muted%20crimson%20ochre%20and%20cream%20tones%2C%20behind%20the%20scenes%20documentary%20aesthetic%2C%20tungsten%20lamp%20glow%2C%20shallow%20depth%20of%20field%2C%20detailed%20texture&width=900&height=560&seq=art-jianji&orientation=landscape',
    content: [
      '看真人秀时，我们常会下意识给某个嘉宾贴上"性格标签"——有人觉得谁谁一直很强势，有人觉得谁谁受了委屈。可如果把同一段原始素材交给不同团队剪，最终呈现的性格可能南辕北辙。剪辑不是删减，而是一次二次创作。',
      '最常用的手法是"反应剪辑"：先给一个事件片段，再接一段嘉宾的特写反应。顺序不同，观众的归因就完全不同——先看冲突再看道歉，会觉得是和解；先看道歉再看冲突，会觉得是施压。所谓人设崩塌或洗白，很多时候正是这种顺序变化造成的观感差异。',
      '节奏上，节目组会用"钩子前置"来留住观众：把一天里最有张力的十几秒提到节目前段反复预演，再在正文里把铺垫拉长制造悬念。理解了这套节奏，你就明白为什么有些"爆点"总来得刚刚好——那不是巧合，是结构。',
      '看料社并不想教读者去"反感剪辑"，恰恰相反，理解了镜头语言，才能更宽容地看待素材里真实的复杂。剪辑放大了某种情绪，但情绪本身，多半还是源自真实发生过的碰撞。',
    ],
  },
  {
    slug: 'tong-ge-gua-du-jie-du-chayi',
    column: 'shenba',
    title: '同一个瓜，为什么不同平台解读能差出十万八千里？',
    lead:
      '同样一条新闻，在某平台是温柔故事，换个平台就成了悬疑剧。我们用三个案例解释：同一事实进入不同算法与社区文化后，为什么会长出不同的脸。',
    tags: ['平台差异', '算法', '社区文化'],
    date: '2026-08-20',
    readTime: '7 分钟',
    author: '灯下',
    cover:
      'https://readdy.ai/api/search-image?query=Editorial%20visual%20of%20one%20newspaper%20article%20reflected%20through%20three%20different%20warm-toned%20magnifying%20glasses%20producing%20distinct%20distorted%20interpretations%2C%20amber%20and%20crimson%20accents%20on%20cream%20paper%2C%20documentary%20conceptual%20illustration%20style%2C%20soft%20cinematic%20lighting%2C%20high%20detail&width=900&height=560&seq=art-dujiedu&orientation=landscape',
    content: [
      '同样一个娱乐事件，常常在几天内被讲成多个版本：有的平台把它处理成"暖心反转"，有的当成"悬疑连续剧"，还有的直接升级成"价值辩论"。当事人还是那些当事人，为什么故事会长出不同的脸？答案藏在平台的"土壤"里。',
      '算法分发平台更看重停留时长与互动密度，因此会优先放大冲突感强、能引发站队的切面；评论区文化更尖锐的平台，容易催生"扒细节"的二创；而重视关系链的社区，则倾向于把事件包装成可以转发的"人设故事"。同一事实，像水一样，倒进不同的容器就成了不同的形状。',
      '这不是平台在恶意操纵，而是推荐系统与用户偏好互相塑造的必然结果。理解了这一点，我们追瓜时就多了一层功课：与其在不同版本里选一个相信，不如回到一手信源，把被各平台裁剪掉的时间线自己拼一遍。',
      '看料社的立场很朴素：事实只有一个大致轮廓，情绪可以有许多种。我们愿意做的，是陪你把轮廓描清楚，至于怎么站队，是读者自己的自由。',
    ],
  },
  {
    slug: 'xianxiangji-ip-qiri-shijianxian',
    column: 'maolu',
    title: '从上线到出圈：一个现象级内容 IP 的七日时间线复盘',
    lead:
      '很多 IP 的爆红都有迹可循。我们把它上线后七天里每天的公开动作按时间排开，形成一张可对照的七日时间线，帮你建立"看爆款"的时间感。',
    tags: ['时间线', 'IP复盘', '出圈节点'],
    date: '2026-09-01',
    readTime: '10 分钟',
    author: '阿刀',
    cover:
      'https://readdy.ai/api/search-image?query=Editorial%20week-at-a-glance%20timeline%20of%20seven%20columns%20on%20warm%20paper%20with%20date%20stamps%2C%20red%20thread%20connecting%20rising%20action%20points%20like%20a%20graph%2C%20ochre%20and%20charcoal%20palette%2C%20documentary%20planning%20wall%20aesthetic%2C%20soft%20cinematic%20light%2C%20high%20detail%20texture&width=900&height=560&seq=art-qiri&orientation=landscape',
    content: [
      '上线不等于会有人看。我们把某个现象级内容 IP 上线后七天的公开动作按日拆解，得到一条值得反复对照的时间线。与其说它神奇，不如说它是"选题 + 节奏 + 运气"三者共振的结果，而前两者是可以被观察的。',
      '第一天到第二天通常属于"验证期"：内容是否被核心用户认可，看的是小圈层内的留存与自发转发，而不是大范围的声量。真正聪明的团队，前两晚不会急着冲热搜，而是盯着评论区里最容易被忽略的"追问"——那往往暗示着下一波内容的方向。',
      '第三天到第五天是"放大期"。此时内容开始被外部搬运与二创，团队会在原基础梗上二次投放物料，把讨论导向更可传播的情绪点。也是在这个阶段，不同平台的分发差异开始显现，量变转为质变通常就发生在这一两天。',
      '第六七天则是"沉淀与长尾"。热度不会永远在高位，能留下来的，是被提炼成稳定记忆点的部分。这条时间线最想说明的其实只有一句：爆红很少是"突然"的，它更像一场被精密安排又被运气加持的接力。',
    ],
  },
  {
    slug: 'fenyong-sanduanshi-maolu',
    column: 'maolu',
    title: '把一场舆论风波拆成"三段式"，脉络立刻变得清晰',
    lead:
      '面对情绪浓烈的争论，先别急着表态。编辑部有一套自己用的三段式拆法：事实层、情绪层、动机层。用这个方法，很多混乱的瓜都能迅速理顺。',
    tags: ['方法论', '舆论拆解', '三段式'],
    date: '2026-08-15',
    readTime: '6 分钟',
    author: '老烟',
    cover:
      'https://readdy.ai/api/search-image?query=Editorial%20diagram%20of%20three%20stacked%20horizontal%20layers%20on%20warm%20paper%20labeled%20with%20fine%20red%20lines%2C%20clean%20minimal%20analytical%20chart%2C%20cream%20linen%20background%2C%20muted%20crimson%20and%20ochre%20accents%2C%20documentary%20editorial%20flat%20design%2C%20subtle%20grain%2C%20high%20detail&width=900&height=560&seq=art-sanduanshi&orientation=landscape',
    content: [
      '每次热点争论起来，最消耗人的不是事件本身，而是把"事实""感受"和"猜测"混在一起讨论。看料社编辑部给自己定了一条纪律：先分层，再发言。我们把任何一场风波拆成三个相互独立又彼此影响的层。',
      '第一层是事实层：谁、在何时、做了什么、说了什么，尽量只保留能被一手信源或录像证实的内容。这一层刻意做得枯燥，因为枯燥意味着可靠。第二层是情绪层：各方被触动了什么、为什么会被放大。情绪无关对错，但它解释了争论为何难以降温。第三层是动机层：在这一层，我们保持谨慎，只做"可能性推演"，不轻易断言。',
      '三段式的价值在于次序。多数争论失控，是因为大家一开始就在动机层互相扣帽子。而一旦先把事实钉牢、把情绪说清，再谈动机，讨论的敌意会明显下降，信息也会更经得起回溯。',
      '这也是我们在每一篇栏目文里坚持的做法——不追求替读者"赢下争论"，而是尽量让读者在下一次争论里，比上一次更清醒。',
    ],
  },
  {
    slug: 'xuantihui-shengchan-yitian',
    column: 'muhou',
    title: '探访内容公司的一天：选题会、排期与那张"爆款 KPI"表',
    lead:
      '在一条条刷屏内容背后，是每天雷打不动的选题会与排期表。我们记录了内容团队的一天，看看所谓"灵感"是如何被流程化管理，又怎样在 KPI 与表达之间挣扎。',
    tags: ['内容生产', '团队日常', '行业观察'],
    date: '2026-08-25',
    readTime: '11 分钟',
    author: '罐头',
    cover:
      'https://readdy.ai/api/search-image?query=Editorial%20scene%20of%20a%20content%20studio%20morning%20meeting%20with%20whiteboard%2C%20schedule%20chart%20and%20coffee%20cups%2C%20warm%20tungsten%20office%20light%2C%20team%20silhouettes%20around%20table%2C%20muted%20rust%20amber%20and%20cream%20palette%2C%20documentary%20photography%2C%20cinematic%20depth%2C%20detailed%20texture&width=900&height=560&seq=art-shengchan&orientation=landscape',
    content: [
      '很多人以为爆款内容公司里住着一群灵感过剩的天才，实际上，大多数团队的一天从一张略显无趣的排期表开始。早上九点的选题会，编辑们把各自攒的"料"搬到桌上，唯一的衡量标准是：这件事值不值得花大家的时间去讲清楚。',
      '日更的残酷在于，它容不下"没有灵感就歇一天"的任性。于是团队把创作流程拆成流水线：选题初审、信源核实、大纲确认、成稿、法务与事实核校、发布。每一步都设了人，目的是把偶然的灵感压缩成可以被稳定管理的产出。',
      '真正让编辑们反复挣扎的，是那张挂在墙上的"爆款 KPI 表"。追热度能换来数据，却常常挤压表达深度；做深度能积累口碑，却要承担数据平淡的风险。多数团队在两极之间走钢丝，这也解释了为什么我们看到的许多内容，既有点尖锐，又带着一层不敢太出格的克制。',
      '记录这一天，不是想美化或贬低任何工种，而是想让你下次刷到内容时，能隐约看见背后那盏还亮着的灯，以及写它的人所面对的那道选择题。',
    ],
  },
  {
    slug: 'quanzi-shequn-zuzhi-jizhi',
    column: 'muhou',
    title: '评论区、超话与粉丝团：流量生态的自组织机制是怎么跑起来的',
    lead:
      '那些看起来"像水军"的整齐刷屏，很多时候其实是真实社群的自组织。我们拆解评论区、超话与粉丝团的日常运营机制，聊聊"热爱的秩序"如何被规训成数据。',
    tags: ['粉丝生态', '社群', '流量机制'],
    date: '2026-08-12',
    readTime: '9 分钟',
    author: '灯下',
    cover:
      'https://readdy.ai/api/search-image?query=Editorial%20illustration%20of%20networked%20discussion%20nodes%20converging%20like%20an%20ecosystem%20map%20on%20warm%20paper%2C%20comment%20bubbles%20connected%20by%20thin%20threads%20to%20a%20central%20spotlight%2C%20muted%20crimson%20and%20ochre%20on%20cream%2C%20documentary%20conceptual%20style%2C%20cinematic%20depth%2C%20fine%20detail&width=900&height=560&seq=art-shequn&orientation=landscape',
    content: [
      '当一个偶像或内容 IP 拥有庞大粉丝群时，其评论区常呈现出惊人的整齐——数据打卡、控评话术、应援排班，样样准时。路人常常一句"是不是买的水军"带过，但深入下去会发现，多数情况下这是一套由真实用户自发建立、又被层层规训的自组织系统。',
      '这套系统有自己的分工：有人负责第一时间抢占热评前排，有人整理物料存档，有人制作反黑与澄清模板。最核心的机制是"排班制"——把零散的应援热情，通过组织化分工，变成可以被预测和量化的持续输出。它最初源于热爱，却在不自觉中被异化成一种被考核的KPI。',
      '矛盾也正出在这里：个体越用力维护"统一"，系统越要求个体牺牲个人表达。当应援成为义务，当每一次发言都要先过一遍"是否会给正主带来风险"的检查，粉丝的自主性就在一次次自我审查中被慢慢消解。',
      '看料社梳理这套机制，不是为了嘲讽任何群体。热爱本身没有错，错的是把热爱交给一套要求你不断自我规训的机器。能看清自己正处在系统的哪一环，本身就是一种难得的清醒。',
    ],
  },
  {
    slug: 'kailiao-sanbufa',
    column: 'fangfa',
    title: '看料三步法：先辨信源，再理时间，后查动机',
    lead:
      '编辑部把多年经验浓缩成一个可以立刻上手的三步法，专门用来对付信息过载与真假难辨的"料"。这篇是看料方法论的开篇，建议收藏反复对照。',
    tags: ['看料指南', '信源鉴别', '编辑部方法'],
    date: '2026-09-02',
    readTime: '7 分钟',
    author: '老烟',
    cover:
      'https://readdy.ai/api/search-image?query=Editorial%20numbered%20method%20diagram%20with%20three%20hand-drawn%20steps%20on%20warm%20notebook%20paper%2C%20a%20single%20fountain%20pen%20and%20red%20tick%20marks%2C%20magnifying%20glass%20resting%20beside%2C%20muted%20crimson%20ochre%20and%20cream%20palette%2C%20documentary%20flat%20lay%20study%2C%20soft%20cinematic%20light%2C%20fine%20grain%20detail&width=900&height=560&seq=art-sanbufa&orientation=landscape',
    content: [
      '很多"翻车"之所以发生，不是因为人不够聪明，而是因为看料时的顺序错了。遇到一条劲爆消息，情绪会催着你立刻转发表态，但编辑的职业病会逼我们慢半拍。这一篇，把编辑部天天在用的顺序分享给你。',
      '第一步，辨信源。看这条消息最早出自哪里：是机构媒体的一手报道，还是个人账号的二手搬运？截图有没有完整上下文？来源越不可追溯，越要给它打折。第二步，理时间。把事件发生、被曝、发酵的先后顺序排出来，很多看似矛盾的版本，其实只是发生在不同时间点。第三步，后查动机。做完前两步再问：谁最希望我相信这个版本？把动机放最后，是防止先入为主地给人定罪。',
      '三步法的关键是"顺序不可乱"。先查动机的人，会在证据不足时就形成立场，之后看到什么都像佐证；而先理清事实的人，即使最终立场不同，也至少站在了可靠的地基上。',
      '这篇文章只是一个起点。后续我们会把每一步展开成独立的长文，配上真实可复盘的案例，让这套方法不只是挂在嘴上的口号，而成为你真的能用起来的工具。',
    ],
  },
  {
    slug: 'jietu-baoliao-zhenjia',
    column: 'fangfa',
    title: '截图满天飞时，如何判断一段"爆料"是真还是加工过的？',
    lead:
      '聊天记录可以拼接，截图可以断章，录屏也可能掐头去尾。这篇给你一套针对"截图型爆料"的核查清单，教你从画面细节里找出加工痕迹。',
    tags: ['反谣言', '截图核查', '媒体素养'],
    date: '2026-08-08',
    readTime: '8 分钟',
    author: '灯下',
    cover:
      'https://readdy.ai/api/search-image?query=Editorial%20forensic%20scene%20examining%20printed%20chat%20screenshots%20on%20warm%20desk%20with%20loupe%20and%20red%20circled%20anomalies%2C%20magnifier%20over%20paper%20evidence%2C%20muted%20crimson%20ochre%20and%20cream%20tones%2C%20documentary%20investigative%20aesthetic%2C%20cinematic%20soft%20light%2C%20detailed%20texture&width=900&height=560&seq=art-jietu&orientation=landscape',
    content: [
      '当一张"聊天记录"截图决定一场舆论的走向时，是否该先问问它有没有被加工过？答案是肯定的。截图不是原始证据，它只是对屏幕的二次呈现，天然具备被裁剪、拼接与断章的可能。这一篇我们给出一份可执行的核查清单。',
      '第一看时间与环境信息：状态栏时间、电量、聊天双方的备注，是否与被说的时间地点自洽；第二看上下文完整性：对方说"好"之前是什么问题，删掉的前文往往是关键；第三看画质异常：突然模糊、分辨率突变、字体重叠，都可能是二次截图的痕迹。更高阶的做法，是去找这段对话在别的信源里是否有呼应，一个人很难在所有地方都圆得毫无破绽。',
      '需要强调的是，加工不等于全盘伪造。有人只是截取了最有利于己方立场的一小段，字字属实，但放在完整语境里却完全误导。这种"选择性真实"比明显造假更难识别，也更需要警惕。',
      '看料社倡导的不是怀疑一切，而是给每条"太顺理成章"的爆料多留一道检查工序。真相往往经得起放大镜，谣言则最怕被追问。',
    ],
  },
];

export const articleBySlug = Object.fromEntries(articles.map((a) => [a.slug, a]));